<template>
  <el-card :title="title" :style="{ height: height + 'px',minHeight:'160px'}"
           style="margin-top: 20px !important;min-width: 358px !important;">
    <div class="tops" id="Agent">
      <div>
        <span style="font-size: 20px;color:'#333';font-weight: 700;width: 100%">{{ title }}</span>
      </div>
      <el-button
          @click="addFriend"
          slot="extra"
          type="primary"
          extra="addfriend"
          link
      >{{ $t("common.more") }}
      </el-button
      >
    </div>

    <div class="mainBox" ref="refScrollTop" slot="content" v-loading="isLoading">
      <div class="item" v-for="item in notifyList" :key="item.id" @click="handleToDetail(item)"
           style="display: flex; justify-content: space-between; align-items: center;">
        <!-- 左侧：标签 + 标题 -->
        <div style="display: flex; align-items: center; flex: 1; overflow: hidden;">
          <div class="tag" style="flex-shrink: 0;">
            <template v-if="item.isTop!==1">
              <el-button v-if="item.consultType===1" size="small" type="info">{{ $t('common.cds37') }}</el-button>
              <el-button v-else-if="item.consultType===2" size="small" type="info">{{ $t('common.cds36') }}</el-button>
              <el-button v-else-if="item.consultType===3" size="small" type="info">{{ $t('common.cds38') }}</el-button>
            </template>
            <template v-else>
              <el-button size="small" type="danger">{{ $t('common.cds40') }}</el-button>
            </template>
          </div>

          <!-- 标题：可截断、可省略 -->
          <div
              :style="{
        marginLeft: '5px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        flex: 1
      }"
              :title="item.title"
          >
            {{ getLimitedTitle(item) }}
          </div>
        </div>

        <!-- 右侧：时间 -->
        <div class="time" style="flex-shrink: 0; margin-left: 10px; white-space: nowrap;">
          {{ item.sendTime ? item.sendTime.split(" ")[0] : item.createTime ? item.createTime.split(" ")[0] : '' }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<script setup>
import {ElCard, ElMessage} from "element-plus";
import Card from "@/components/Card.vue";
import {ref, defineEmits, onMounted, computed} from "vue";
import {queryNoticeList} from "@/api/home";
import {debouncePlus} from "@/utils/mylodash";
import {useRouter} from "vue-router";
import {useStore} from "vuex";

const props = defineProps({
  title: {
    type: String,
  },
  height: {
    type: String,
    default: '400'
  },
  list: {
    type: Array,
    default: () => [],
  },
  extra: String,
})

const router = useRouter()
const store = useStore()
const test = ref(false)
const emit = defineEmits(["addFriend"])
const addFriend = () => {
  emit("addFriend");
};

function getLimitedTitle(item) {
  const maxLen = item.consultType !== null || !(item.isTop !== 1) ? 18 : 21
  console.log(maxLen, 'maxLen')
  return item.title?.length > maxLen ? item.title.slice(0, maxLen) + '…' : item.title
}


// 公告资讯
const pageNo = ref(1);
const totalPages = ref(1)
const pageSize = ref(4);
const notifyList = ref([])
const total = ref(0)
const isLoading = ref(false)
const isCurrent = ref(false)
const queryNoticeListApis = async () => {
  isLoading.value = true
  const payload = {
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    type: 3
  }
  const res = await queryNoticeList(payload)
  if (res.code !== 200) {
    isLoading.value = false
    ElMessage.error(res.message)
    return
  }
  isLoading.value = false
  const {records} = res.result.data
  if (!isCurrent.value) {
    notifyList.value = records;
  } else {
    notifyList.value = [...notifyList.value, ...records]
  }
  console.log('res.result', res.result)
  totalPages.value = res.result.pages;
  total.value = res.result?.total;
}

onMounted(async () => {
  await queryNoticeListApis()
})


const refScrollTop = ref(null)
const List = ref(null)
const handleScroll = debouncePlus(async (event) => {
  const element = event.target;
  console.log("scroll", element.scrollHeight, element.scrollTop, element.clientHeight)
  refScrollTop.value = element.scrollTop;
  const tolerance = 5;
  if (element.scrollTop >= (element.scrollHeight - element.clientHeight - tolerance)) {
    if (totalPages.value === pageNo.value) {
      return;
    } else {
      isCurrent.value = true
      pageNo.value++;
      await queryNoticeListApis()
    }
  }
}, 200)

const handleToDetail = async (item) => {
  // 更新 阅读状态
  await store.dispatch("message/updateReadCountApis", {id: item.id})
  const targetResult = notifyList.value.map(it => {
    if (it.id === item.id) {
      return {...it, readCount: it.readCount + 1}
    } else {
      return {...it}
    }
  })
  await store.commit("message/setNotifyList", targetResult)
  await queryNoticeListApisUnReadApi()
  openNewTab('/messageDetail', {id: item.id})
}

const queryNoticeListApisUnReadApi = async () => {
  const payload = {
    pageNo: 1,
    pageSize: 1,
    type: 3,
  }
  await store.dispatch("message/queryNoticeListApisUnRead", payload)
}

const openNewTab = (path, query = {}) => {
  const routeInfo = router.resolve({path, query});
  window.open(routeInfo.href, '_blank');
};
</script>

<style lang="less" scoped>
.title {
  font-size: 20px;
  color: #333;
}

.mainBox {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  word-break: break-word;
  text-align: center;
  height: max-content;
}

.item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 22px;
  margin: 4px 0px !important;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  cursor: pointer;
  transition: all .3s;
}

.item:nth-of-type(1) {
  margin: 0px 0px 4px 0px !important;
}

.item:nth-of-type(3) {
  margin: 4px 0px 4px 0px !important;
}

.box {
  width: 32px;
  height: 32px;
  background-size: 32px 32px;
  background-repeat: no-repeat;
  margin: 0 auto;
}

.content,
.number {
  line-height: 1;

}

.tops {
  display: flex;
  justify-content: space-between;
  height: 20px !important;
}

:deep(.el-card__body) {
  min-width: 309px !important;
  padding: 15px !important
}

.bold {
  font-weight: 700;
}

.time {
  width: max-content;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-right: 4px;
}

:deep(.el-button--info) {
  background: #f5f5f5 !important;
  font-size: 12px !important;
  color: #000000;
  border: none !important;
  width: 41px !important;
  height: 22px !important;
}

:deep(.el-button--danger) {
  background: #ca5040 !important;
  font-size: 12px !important;
  color: white;
  border: none !important;
  width: 41px !important;
  height: 22px !important;
}

//.mainBox {
//  overflow: auto;     /* 或 scroll，确保内容可滚动 */
//  -ms-overflow-style: none;  /* IE 和 Edge */
//  scrollbar-width: none;     /* Firefox */
//}
//
//.mainBox::-webkit-scrollbar {
//  display: none;      /* Chrome、Safari、Opera */
//}

:deep(.el-button) {
  min-width: 40px;
  width: max-content !important;
  height: 20px;
  line-height: 20px
}
</style>
    